import { BaseComponent } from './base.component';
import { Store, StoreHelper, UserService } from '../services';
import { HeaderAction } from './header-action';
import { IAppEvent } from './app-event';

export class TopLevelComponent extends BaseComponent {

    empty = false;
    loading = false;

    private _headerActionCallback: Function;
    private headerBackActionCallback: Function;
    private _headerActions: HeaderAction[];

    constructor(public store: Store, public storeHelper: StoreHelper, userService: UserService) {
        super(store, storeHelper, userService);
    }

    set headerTitle(header: string) {
        setTimeout(() => this.store.pushAppEvent({ type: 'title', data: header }), 0);
    }

    set headerActions(headerActions: HeaderAction[]) {
        if (!headerActions) {
            headerActions = [];
        }

        this._headerActions = headerActions;
        this.storeHelper.update('headerActions', headerActions);
    }

    subscribeToHeaderActions(headerActionCallback: (headerAction: HeaderAction) => void) {
        if (!headerActionCallback) {
            return;
        }

        this._headerActionCallback = headerActionCallback;
        this.store.appEvents$.subscribe((appEvent: IAppEvent) => this._processAppEvent(appEvent));
    }

    subscribeToBackHeaderAction(headerBackActionCallback: () => void) {
        if (!headerBackActionCallback) {
            return;
        }

        this.headerBackActionCallback = headerBackActionCallback;
        this.store.appEvents$.subscribe((appEvent: IAppEvent) => {
              if (appEvent.type === 'backAction') {
                  this.headerBackActionCallback();
              }
        });
    }

    private _processAppEvent(appEvent: IAppEvent) {
      if (appEvent.type === 'action') {
          let action = this._headerActions.find(action => action.id === appEvent.data.id);

          if (action) {
              this._headerActionCallback(action);
          }
      }
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/top-level.component.ts